import { t } from "i18next";
import React, { useState } from "react";
import {
  StatusSelect,
  RegistrationStatuses,
  EntryTypes,
} from "../../components";
import { Layout } from "../../components/layout";
import { Filters } from "../../components/tournaments/filters/Filters";
import { TournamentList } from "../../components/tournaments/tournamentList/TournamentList";
import "./Tournaments.scss";

const Tournaments = () => {
  const [panelOnep, setPanelOpen] = useState(true);
  const [betsLipOpen, setBetsLipOpen] = useState(false);
  return (
    <Layout
      addClasses={`page-full-size ${
        betsLipOpen ? "betslip-Full" : "betslip-Hidden"
      } ${panelOnep ? "smart-panel-is-visible" : ""}`}
      panelOnep={panelOnep}
      setPanelOpen={setPanelOpen}
      navStatus={"tournaments"}
      betsLipPage={""}
      betsLipOpen={betsLipOpen}
      setBetsLipOpen={setBetsLipOpen}
    >
      {/* <Filters /> */}
      {/* <TournamentList /> */}
      <div className="casino-game-tournament-filter">
        <div className="componentFilterWrapper-bc">
          <div className="componentFilterBody-bc">
            <div className="componentFilterElsWrapper-bc">
              <div className="filter-form-w-bc">
                <div className="componentFilterBody-content">
                  <StatusSelect />
                  <RegistrationStatuses />
                  <EntryTypes />
                </div>
                <div className="u-i-p-c-filter-footer-bc">
                  <button className="btn a-color " type="submit" title="Show">
                    <span>{t("admin.Show")}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="empty-b-text-v-bc">
        {t("admin.Therearenotournamentswithselectedfilters")}.
      </p>
    </Layout>
  );
};

export { Tournaments };
